import { gqlClient } from '@/api/graphql-client';
import timelogKeys from '@/api/queries/timelog/keyFactor';
import { graphql } from '@/gql';
import {
  GetTimelogsInput,
  GetTimelogsQuery,
  PaginationInput,
} from '@/gql/graphql';
import { PAGINATION_ARG_DEFAULTS } from '@payaca/shared-isomorphic/constants/graphql-pagination';
import { useQuery } from '@tanstack/react-query';

const GET_TIMELOGS = graphql(`
  query GetTimelogs($input: GetTimelogsInput, $pagination: PaginationInput!) {
    timelogs(input: $input, pagination: $pagination) {
      limit
      offset
      totalCount
      totalDuration
      totalCost {
        value
        currency {
          id
          code
          exponent
        }
      }
      items {
        id
        endTime
        startTime
        type {
          id
          name
        }
        user {
          id
          fullName
          firstName
          lastName
          email
          colour
          avatarUrl
          costPerHour {
            value
            currency {
              id
              code
              exponent
            }
          }
        }
        duration
        costPerHour {
          value
          currency {
            id
            code
            exponent
          }
        }
        cost {
          value
          currency {
            id
            code
            exponent
          }
        }
        notes
      }
    }
  }
`);

export type Timelog = GetTimelogsQuery['timelogs']['items'][0];

export const useGetTimelogs = (
  input?: GetTimelogsInput,
  pagination?: PaginationInput
) => {
  const paginationInput = pagination || PAGINATION_ARG_DEFAULTS;

  return useQuery({
    queryKey: timelogKeys.list(input, paginationInput),
    queryFn: () => {
      return gqlClient.request(GET_TIMELOGS, {
        input,
        pagination: paginationInput,
      });
    },
  });
};
